<template>
    <div class="cart-items-list">
        <CartItem
            v-for="item in cart.items"
            :key="item.id"
            :item="item"
            :disabled="cart.isUpdating || cartPayment.isProcessingPayment"
            :quantityDigits="cartItemsQuantityDigits"
            :showInternalNames="props.showInternalNames"
        />

        <div class="nodata" v-if="!cart.hasItems">
            <div class="lbl">
                {{ translations.cart.noItems }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useCartStore } from "@/data/stores/cart";
    import { useCartPaymentStore } from "@/data/stores/cartPayment";
    import { translations } from "@/shared/localization/translations";
    import { computed } from "vue";

    import CartItem from "./CartItem.vue";

    const cart = useCartStore();
    const cartPayment = useCartPaymentStore();

    // define properties
    const props = defineProps<{
        showInternalNames: boolean;
    }>();

    // define computed
    const cartItemsQuantityDigits = computed(() => {
        let maxLength = 1;
        for (const item of cart.items) {
            const itemDigits = item.quantity.toString().length;
            maxLength = Math.max(maxLength, itemDigits);
        }
        return maxLength;
    });
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .cart-items-list {
        font-size: 16px;
        padding: 0 1.5em;
        color: colors.$fontColor;

        > .nodata {
            > .lbl {
                font-size: 0.875em;
            }
        }
    }
</style>
